import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subsCriptionService } from 'features/subscription-management/services/SubsCription.service';
import { toast } from 'react-hot-toast';

export const useCreateSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (subscriptionData) => subsCriptionService.addSubscription(subscriptionData),
    onSuccess: () => {
      queryClient.invalidateQueries(['subscriptions']);
      toast.success('Subscription created successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to create subscription');
    },
  });
};

export const useUpdateSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ subscriptionId, subscriptionData }) =>
      subsCriptionService.updateSubscription({ subscriptionId, subscriptionData }),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(['subscriptions']);
      queryClient.invalidateQueries(['subscriptions', variables.subscriptionId]);
      toast.success('Subscription updated successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update subscription');
    },
  });
};

export const useDeleteSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (subscriptionId) => subsCriptionService.deleteSubscription(subscriptionId),
    onSuccess: () => {
      queryClient.invalidateQueries(['subscriptions']);
      toast.success('Subscription deleted successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete subscription');
    },
  });
};
